import React from 'react';
import { Group, Text, ConditionalWrapper } from '@landr/maestro';
import { Link } from 'react-router-dom';
import { css } from '@landr/styled-system/css';
import getSamplesAndPacksByline from '../helpers/getSamplesAndPacksByline';

const bylineWrapperStyles = css({
    maxWidth: { base: '80%', md: 'calc(50% - {spacing.md})' },
    overflow: 'hidden',
    alignSelf: 'center',
});

const customTextStyles = css({
    display: 'block',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
});

const providerLinkStyles = css({
    fontWeight: 'bold',
    color: 'text.medium',
});

const separator = ' · ';

const _Byline = ({
    packsAndSamples,
    partnerLink,
    partnerName,
    separator,
}: {
    packsAndSamples?: string;
    partnerLink?: string;
    partnerName?: string;
    separator: string;
}) => (
    <Group.Item className={bylineWrapperStyles}>
        <Text
            className={customTextStyles}
            textStyle="body-sm"
            lineHeight="md"
            color="text.medium"
        >
            {partnerName && (
                <>
                    <ConditionalWrapper
                        condition={!!partnerLink}
                        wrapper={(
                            children: React.ReactNode,
                        ): React.ReactNode => (
                            <Link
                                to={partnerLink ?? ''}
                                className={providerLinkStyles}
                            >
                                {children}
                            </Link>
                        )}
                    >
                        {partnerName}
                    </ConditionalWrapper>
                    {separator}
                </>
            )}
            {packsAndSamples}
        </Text>
    </Group.Item>
);

const Byline: React.FC<{
    partnerName?: string;
    partnerLink?: string;
    sampleCount?: number;
    packCount?: number;
}> = ({ partnerName, partnerLink, sampleCount, packCount }) => {
    const packsAndSamples = getSamplesAndPacksByline({
        sampleCount,
        packCount,
        separator,
    });

    return (
        <_Byline
            packsAndSamples={packsAndSamples}
            partnerLink={partnerLink}
            partnerName={partnerName}
            separator={separator}
        />
    );
};

Byline.displayName = 'PageHeader.Byline';

export default Byline;
